<template>
    <div>
      <!-- 面包屑导航 -->
      <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>钱包管理</el-breadcrumb-item>
      </el-breadcrumb> -->
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="搜索：">
          <el-input size="small" v-model="formInline.user" placeholder="输入用户"></el-input>
        </el-form-item>
      <el-form-item label="时间">
        <el-date-picker
        size="small"
        v-model="timeVal"
        value-format="yyyy-MM-dd"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
      <!--列表-->
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <!-- show-summary -->
        <el-table-column align="center" prop="amount" label="销毁数量" >
        </el-table-column>
        <el-table-column align="center" label="类型" min-width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.type == 'fee'"><el-tag  type="warning" size="medium" Plain>手续费</el-tag></div>
            <div v-if="scope.row.type == 'sys_buy'"><el-tag size="medium" Plain>系统购买</el-tag></div>
          </template>
      </el-table-column>
        <el-table-column align="center" prop="setupTime" label="结束时间" >
        </el-table-column>
         
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
  </template>
  
  <script>
  import { c2cBurnList } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        // rules表单验证
        formInline: {
          from: 1,
          limit: 10,
          startTime: "",
          endTime: ""
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        timeVal:""
      }
    },
    // 注册组件
    components: {
      Pagination
    },
  
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
  
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取转入列表
      getdata(parameter) {
        this.loading = true
        c2cBurnList(parameter)
          .then(res => {
            this.loading = false
            if (res.code != 0) {
              this.$message({ 
                type: 'info',
                message: res.message
              })
            } else {
              this.listData = res.data.list
              // 分页赋值
              // this.pageparm.currentPage = this.formInline.from
              // this.pageparm.pageSize = this.formInline.limit
              this.pageparm.total = res.data.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('列表加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.pageparm.pageSize = parm.pageSize
        this.formInline.from = (parm.currentPage-1)*(this.pageparm.pageSize) + 1
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.pageparm.currentPage = 1
        this.formInline.from = 1
        console.log(this.timeVal)
        if(this.timeVal instanceof Array){
          this.formInline.startTime = this.timeVal[0]+' 00:00:00'
          this.formInline.endTime = this.timeVal[1]+' 23:59:59'
        }else{
          this.formInline.startTime = ''
          this.formInline.endTime = ''
        }
        this.getdata(this.formInline)
      }
    }
  }
  </script>
  
  <style scoped>
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
  </style>
  
   
   


// WEBPACK FOOTER //
// src/views/c2c/burnList.vue